module.exports = __webpack_public_path__ + "static/fonts/SourceSansPro-Bold.50d2f83.woff2";